import * as React from 'react';

export default function useScrollTrigger(value: number) {
  const [trigger, setTrigger] = React.useState(false);
  const timerRef = React.useRef<ReturnType<typeof setTimeout> | null>(null);
  React.useEffect(() => {
    setTrigger(document.documentElement.scrollTop > value);
    const handleScroll = () => {
      if (timerRef.current !== null) return;
      timerRef.current = setTimeout(() => {
        setTrigger(document.documentElement.scrollTop > value);
        timerRef.current = null;
      }, 100);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', handleScroll);
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
    };
  }, [value]);
  return trigger;
}
